import { Default } from "./Default";
export { Dark, mediumFont, defaultFont, largeFont } from "./Default";
// eslint-disable-next-line import/no-anonymous-default-export
export default { Default };
